import {
    CREATE_AGREEMENT_START,
    CREATE_AGREEMENT_ERROR,
    NEW_AGREEMENT_DATA_RECEIVED,
} from './agreementActionTypes';

const initialState = {
    error: false,
    loading: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NEW_AGREEMENT_DATA_RECEIVED:
            return {
                data: {
                    ...state.data,
                    ...action.payload.data,
                },
                loading: false,
                error: false,
            };
        case CREATE_AGREEMENT_START:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case CREATE_AGREEMENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/agreementReducer.js